module.exports = __webpack_public_path__ + "static/media/img4-4.13c7b1b0.png";